// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["web/themes/design-system-colas/build/css/style"], () => (__webpack_require__("./web/themes/design-system-colas/assets/js/script.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["web/themes/design-system-colas/build/css/style"], () => (__webpack_require__("./web/themes/design-system-colas/assets/scss/style.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
